import React, {useContext} from "react";
import "./MtplTarifficationDescriptionStyles.scss"
import {strings} from "../../../../strings/strings";
import {QuotationContext} from "../../../../contexts/QuotationContext";
import {MtplQuotation} from "../../../../model/quotation";
import {isSmartDrive} from "../../../../utils/quotation";
import {TarifficationDescription} from "./TarifficationDescription";

export const MTPLTarifficationDescription = () => {
    const {tarrificationProgram} = useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const stringsData = isSmartDrive(tarrificationProgram) ? {
        title: strings.tarifficationDescriptionHeaderSmartDrive,
        lines: [strings.tarifficationDescriptionElement1SmartDrive,
            strings.tarifficationDescriptionElement2SmartDrive,
            strings.tarifficationDescriptionElement3SmartDrive]
    } : {
        title: strings.tarifficationDescriptionHeader,
        lines: [strings.tarifficationDescriptionElement1,
            strings.tarifficationDescriptionElement2]
    }

    return <TarifficationDescription title={stringsData.title} lines={stringsData.lines} />
}
